import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Spin,
} from "antd";
import { useForm } from "react-hook-form";
import {
  apiConfig,
  GetLabelForReportParameter,
  labelConfig,
  staticConfig,
} from "../reports.config";
import { BOM } from "../../../services/definedMethod";
import CalendarIcon from "@untitled-ui/icons-react/build/esm/Calendar";
import React, { useState } from "react";
import cnt from "../../../services/definedConstant";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
function ParameterSelector({
  fields,
  session,
  customerReportsList,
  columnHeaders,
  isRun,
  setCustomerReportsList,
  setColumnHeaders,
  setIsRun,
}) {
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [_fields, setFields] = React.useState([]);
  const [dynamicFieldsId, setDynamicFieldsId] = useState([]);
  console.log(dynamicFieldsId);
  const [isLoading, setIsLoading] = useState(false);
  const options = [
    { label: "Zero Decimal Places", value: 0 },
    { label: "4", value: 4 },
    { label: "3", value: 3 },
    { label: "2", value: 2 },
    { label: "1", value: 1 },
    { label: "0", value: 0 },
  ];
  React.useEffect(() => {
    const temp = _fields?.filter(
      (item) =>
        dynamicFieldsId.includes(item.row[0]) &&
        !_fields.find((items) => items.row.includes(item.row[0]))
    );
    setFields([..._fields, ...temp]);
  }, [dynamicFieldsId]);

  React.useEffect(() => {
    setFields(fields.data);
  }, [fields]);

  console.log(dynamicFieldsId, _fields);

  const onSubmit = (formValues) => {
    console.log(formValues);
    delete formValues.decimalPlaces;

    const params = {
      ...Object.fromEntries(
        Object.entries(formValues).map(([key, value]) => [
          `R_${key}`,
          value && value.isValid && value.isValid()
            ? value.format("YYYY-MM-DD")
            : value,
        ])
      ),
    };
    console.log(params);
    const url = `${apiConfig.RunReports}/${state.name}`;

    const body = {
      session,
      params,
    };

    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err?.developerMessage);
      } else {
        const objList = res;
        setColumnHeaders(objList.columnHeaders);
        let tempCustomerReportsList = [];

        objList?.data?.forEach((element, index) => {
          // tempCustomerReportsList.push({
          //   key: index,
          //   id: index,
          //   office: element.row[0],
          //   clientAccountNo: element.row[1],
          //   name: element.row[2],
          //   status: element.row[3],
          //   activationDate: element.row[4],
          //   externalId: element.row[5] ? element.row[5] : "-",
          // });
          const obj = {};
          objList.columnHeaders.forEach((header, i) => {
            const row = element.row[i];
            obj[header.columnName] =
              !isNaN(Number(row)) && String(row).includes(".")
                ? Number(row).toFixed(2)
                : row;
            // obj[header.columnName] = !isNaN(Number(row)) ? Number(row).toFixed(2) : row;
            // obj[header.columnName] = row;
          });
          console.log(obj);
          tempCustomerReportsList.push(obj);
          // tempCustomerReportsList.push({
          //   objList[0] : element.row[i],
          // });
        });

        setCustomerReportsList(tempCustomerReportsList);
        setIsRun(true);
        //STOP LOAD
        setIsLoading(false);
        // useForm.resetFields();
      }
    });
  };
  return (
    <Form form={form} layout="vertical" onFinish={onSubmit}>
      {!isRun && (
        <Spin spinning={isLoading} size="large">
          <Row>
            {_fields?.map((field, index) => {
              const exists = dynamicFieldsId.includes(field.row[0]);
              const isDependent = field.row[8];
              if (!isDependent || (isDependent && exists))
                return (
                  <FieldItem
                    show={!isRun}
                    field={field}
                    fields={_fields}
                    dynamicFieldsId={dynamicFieldsId}
                    setDynamicFieldsId={setDynamicFieldsId}
                    session={session}
                    key={index}
                    form={form}
                  />
                );
              // if (isDependent && exists)
              //   return (
              //     <FieldItem
              //       field={field}
              //       fields={_fields}
              //       dynamicFieldsId={dynamicFieldsId}
              //       setDynamicFieldsId={setDynamicFieldsId}
              //       session={session}
              //       key={index}
              //       form={form}
              //     />
              //   );
            })}
            {!isRun && (
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  rules={[
                    {
                      required: true,
                      message: "Please select " + "Decimal Places",
                    },
                  ]}
                  label={"Decimal places"}
                  name={"decimalPlaces"}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      "Decimal Places",
                      "select"
                    )}
                    style={{ height: "44px" }}
                    options={options}
                  />
                </Form.Item>
              </Col>
            )}
          </Row>
          {!isRun && (
            <Row>
              <Divider />
              <Button
                type="primary"
                htmlType="submit"
                style={{
                  background: "#BA24D5",
                  borderColor: "#BA24D5",
                  height: 44,
                  fontSize: 16,
                  marginLeft: "auto",
                }}
              >
                Run Report
              </Button>
            </Row>
          )}
        </Spin>
      )}
    </Form>
  );
}

const FieldItem = ({
  field,
  session,
  form,
  show,
  dynamicFieldsId,
  setDynamicFieldsId,
  fields,
}) => {
  const valueName = field.row[1];
  const label = GetLabelForReportParameter(field.row[0]);
  const optName = field.row[0];
  const name = field.row[2];
  const type = field.row[3];
  const dataType = field.row[4];
  const dependentField = fields.find((item) => item.row[8] === field.row[0]);
  // const dependentField = field.row[6];
  const isSelectAll = field.row[7];
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = React.useState([]);
  const value = Form.useWatch(valueName, form);
  const officeId = Form.useWatch("officeId", form);
  const currency = Form.useWatch("currencyId", form);
  console.log(options, "options");

  const isSelect = type === "select";
  const isSelectGl =
    isSelect &&
    (valueName?.toLowerCase() === "glaccountno" ||
      valueName?.toLowerCase() === "parentgl");

  function getOptions() {
    const params = {
      // R_reportListing: `'${state.name}'`,
      parameterType: true,
    };

    const url = `${apiConfig.RunReports}/${optName}`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
      } else {
        const opts = res.data.map((element) => ({
          value: element?.row[0],
          label: element?.row[1],
        }));

        isSelectAll
          ? setOptions([...opts, { value: "-1", label: "All" }])
          : setOptions([...opts]);
      }
    });
    setIsLoading(false);
  }
  function getLoanOfficerOptions() {
    const params = {
      // R_reportListing: `'${state.name}'`,
      parameterType: true,
      R_officeId: officeId,
    };

    const url = `${apiConfig.RunReports}/${optName}`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
      } else {
        console.log(res);
        const opts = res.data.map((element) => ({
          value: element?.row[0],
          label: element?.row[1],
        }));

        isSelectAll
          ? setOptions([...opts, { value: "-1", label: "All" }])
          : setOptions([...opts]);
      }
    });
    setIsLoading(false);
  }
  function getproductOptions() {
    const params = {
      // R_reportListing: `'${state.name}'`,
      parameterType: true,
      R_currencyId: currency,
    };

    const url = `${apiConfig.RunReports}/${optName}`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
      } else {
        console.log(res);
        const opts = res.data.map((element) => ({
          value: element?.row[0],
          label: element?.row[1],
        }));

        isSelectAll
          ? setOptions([...opts, { value: "-1", label: "All" }])
          : setOptions([...opts]);
      }
    });
    setIsLoading(false);
  }

  React.useEffect(() => {
    isSelect && !officeId && !currency && getOptions();
    officeId && getLoanOfficerOptions();
    currency && getproductOptions();
  }, [officeId, currency]);

  React.useEffect(() => {
    console.log("value", value);
    console.log("dependentField", dependentField);
    if (value && dependentField) {
      const fieldToPush = fields?.find((item) => item.row[8] === optName);
      if (!fieldToPush) return;
      setDynamicFieldsId([...dynamicFieldsId, fieldToPush.row[0]]);
    }
  }, [value]);

  // Custom search for Select options whose label is like "<productName> - <accountNo>"
  const filterAccountOption = (input, option) => {
    if (!option || typeof option.label !== "string") return false;
    const query = (input || "").toLowerCase();
    const label = option.label.toLowerCase();
    return label.includes(query);
  };

  console.log(options);
  // if (!show) return <></>;
  if (isSelect && !isSelectGl)
    return (
      <Col span={8} style={{ padding: "0px 8px" }}>
        <Form.Item
          rules={[
            {
              required: true,
              message: "Please select " + label,
            },
          ]}
          label={label}
          name={valueName}
        >
          <Select
            placeholder={BOM.handlePlaceholderMsg(label, "select")}
            style={{ height: "44px" }}
            options={options}
          />
        </Form.Item>
      </Col>
    );
  if (isSelectGl)
    return (
      <Col span={8} style={{ padding: "0px 8px" }}>
        <Form.Item
          rules={[
            {
              required: true,
              message: "Please select " + label,
            },
          ]}
          label={label}
          name={valueName}
        >
          <Select
            placeholder={BOM.handlePlaceholderMsg(label, "select")}
            style={{ height: "44px" }}
            options={options}
            showSearch
            filterOption={filterAccountOption}
          />
        </Form.Item>
      </Col>
    );
  if (type === "date") {
    console.log(valueName);
    return (
      <Col span={8} style={{ padding: "0px 8px" }}>
        <Form.Item
          label={label}
          name={valueName}
          rules={[
            () => ({
              validator(_, value) {
                if (!value) {
                  return Promise.reject(
                    new Error(`Please select ${label} date`)
                  );
                }

                // Get current field name and other date field
                const currentFieldName = valueName;
                const startDate = form.getFieldValue("startDate");
                const endDate = form.getFieldValue("endDate");

                // If this is the end date field, check if it's before start date
                if (currentFieldName === "endDate" && startDate) {
                  if (value.isBefore(startDate, "day")) {
                    return Promise.reject(
                      new Error(
                        `End date must not be earlier than start date (${startDate.format(
                          "YYYY-MM-DD"
                        )})`
                      )
                    );
                  }
                }

                // If this is the start date field, check if end date is before it
                if (currentFieldName === "startDate" && endDate) {
                  if (endDate.isBefore(value, "day")) {
                    return Promise.reject(
                      new Error(
                        `Start date must not be later than end date (${endDate.format(
                          "YYYY-MM-DD"
                        )})`
                      )
                    );
                  }
                }

                return Promise.resolve();
              },
            }),
          ]}
          validateTrigger={["onChange", "onBlur"]}
        >
          <DatePicker
            style={{ marginBottom: 0, width: "100%" }}
            placeholder="Select date"
            suffixIcon={<CalendarIcon color="#667085" width={20} />}
            className="bond-date-picker custom-input"
          />
        </Form.Item>
      </Col>
    );
  }
  if (type === "text")
    return (
      <Col span={8} style={{ padding: "0px 8px" }}>
        <Form.Item
          label={label}
          name={valueName}
          rules={[
            () => ({
              validator(_, value) {
                if (!value) {
                  return Promise.reject(new Error(`Please enter ${label}`));
                }

                return Promise.resolve();
              },
            }),
          ]}
          validateTrigger={["onChange", "onBlur"]}
        >
          {dataType === "string" && (
            <Input
              placeholder={BOM.handlePlaceholderMsg(label)}
              className="custom-input"
            />
          )}
          {/* {dataType === "number" && (
            <InputNumber
              className="of-bold-disable-input"
              formatter={(value) => value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              parser={(value) => (value ? value.replace(/(,*)/g, "") : "")}
              disabled
              placeholder="10000"
              style={{ height: "44px", width: "100%" }}
              prefix="₦"
            />
          )} */}
          {dataType === "number" && (
            <InputNumber
              placeholder={BOM.handlePlaceholderMsg(label)}
              style={{ width: "100%", height: "44px" }}
              prefix=" "
            />
          )}
        </Form.Item>
      </Col>
    );
  return <></>;
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, null)(ParameterSelector);
